/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Filtered_Empty_Title_OneInputs */



/**
* | output |
* | --- |
* | "No partner matches this filter" |
*
* @param {Partner_Billing_Board_Filtered_Empty_Title_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_filtered_empty_title_one = /** @type {((inputs?: Partner_Billing_Board_Filtered_Empty_Title_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Filtered_Empty_Title_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Partner entspricht diesem Filter")
	return /** @type {LocalizedString} */ ("No partner matches this filter")
});